<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="名称" prop="name">
        <Input v-model="form.name"></Input>
      </FormItem>
      <FormItem label="金融公司" prop="companyName">
        <Select v-model="form.companyName">
          <Option v-for="(item,index) in financeData" :value="item.cValue" :key="'f'+index">{{ item.cValue }}</Option>
        </Select>
      </FormItem>
      <FormItem label="每期价格(元)" prop="stagesPrice">
        <Input v-model="form.stagesPrice"></Input>
      </FormItem>
      <FormItem label="结算方式" prop="clearingType">
        <sl-select v-model="form.clearingType" dict="$$cycle" value-type="string" /></sl-select>
      </FormItem>
      <FormItem label="分期数" prop="stagesNum">
        <Dropdown trigger="click" @on-click="handleSetStagesNum" style="width:100%;">
          <InputNumber style="width:100%" :min="1" placeholder="请输入分期数" v-model="form.stagesNum">
            <!-- <span v-show="form.clearingType" slot="append">期({{cycleTitle}})</span> -->
          </InputNumber>
          <DropdownMenu slot="list">
            <DropdownItem v-for="item in stagesNums" :name="item.value" >{{item.label}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div style="font-size:11px;color:rgba(0,0,0,.65);line-height: 1.5em;padding:8px 0;">
<!--           <table class="tip">
            <thead>
              <tr>
                <th></th>
                <th>日</th>
                <th>周</th>
                <th>月</th>
                <th>季度</th>
                <th>年</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1年</td>
                <td>365</td>
                <td>52</td>
                <td>12</td>
                <td>4</td>
                <td>1</td>
              </tr>
              <tr>
                <td>2年</td>
                <td>730</td>
                <td>104</td>
                <td>24</td>
                <td>8</td>
                <td>2</td>
              </tr>
              <tr>
                <td>2年</td>
                <td>1095</td>
                <td>156</td>
                <td>36</td>
                <td>12</td>
                <td>3</td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </FormItem>
      <FormItem label="描述" prop="remark">
        <Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" v-model="form.remark"></Input>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: right; padding-top:12px;">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
const clearingTypeMap = {
  '1':365,//day
  '2':52,//week
  '3':12,//month
  '4':4,//season
  '5':2,//half year
  '6':1,//year
}
export default {
  props: {},
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur,change' },
        ],
        companyName: [
          { required: true, message: '请选择金融公司', trigger: 'blur,change' },
        ],
        stagesPrice: [
          { required: true, message: '请输入分期价格', trigger: 'blur,change' },
        ],
        stagesNum: [
          { type:'number',required: true, message: '请选择分期数', trigger: 'blur,change' },
        ],
        clearingType: [
          { required: true, message: '请选择分期方式', trigger: 'blur,change' },
        ]
      },
      form: {
        id: null,
        name: null,
        companyName: null,
        stagesPrice: null,
        stagesNum: null,
        clearingType: null
      },
      loading: false,
      modalVisible: false,
      financeData: [],
      cycleData: [],
    }
  },

  computed: {
    itemTitle() {
      return '新增计费规则'
    },
    rulesDisplay(){

    },
    stagesNums(){
      let clearingTypeMap = [0,365,52,12,4,2,1]
      let clearingType = this.form.clearingType
      let ranges = [1,2,3,4,5]
      if(clearingType>=1 && clearingType<=6){
        let cycle = clearingTypeMap[clearingType]
        return ranges.map(i => {
          return {value:cycle*i , label:`${cycle*i}期 / ${i}年`}
        })
      }else{
        return []
      }
    },
    cycleTitle(){
      let clearingType = this.form.clearingType
      let cyclesTitle = [,'日','周','月','季度','半年','年']
      if(clearingType>=1 && clearingType<=6){
        return cyclesTitle[clearingType]
      }else{
        return ''
      }
    }
  },
  watch: {
    'form.clearingType'(nv){
      console.log(nv)
    }
  },

  mounted() {
    // init
    this.finance()
  },

  methods: {
    finance() {
      this.$request.ruleKV('finance').then(resp => {
        this.financeData = resp.data || []
      })
    },

    save() {
      let params = { ...this.form }

      this.loading = true
      let promise = this.form.id ? this.$request.ruleUpdate : this.$request.ruleCreate
      promise(params).then(resp => {

        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          this.hide()
        }
        this.loading = false
      })

    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleSetStagesNum(value){
      this.form.stagesNum = parseInt(value)
    },
    show() {
      this.modalVisible = true
    },
    hide() {
      this.modalVisible = false
    }
  }
}

</script>
<style lang="scss" scoped>
  table.tip{
    td,th{
      padding:5px 8px;
      text-align: center;
    }
  }
</style>